/* eslint-disable react/jsx-no-target-blank */
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomRouter from 'src/hooks/useCustomRouter';
import usePaginaCompra from 'src/reducers/PaginaCompra/usePaginaCompra';
import { ButtonBar } from './components/BeneficiarioActionButton';
import { Checkbox } from 'primereact/checkbox';

const BeneficiarioItem = ({
  beneficiario,
  index,
  showHeader = true,
  camposKey = 'camposBeneficiarios',
  showDelete = true,
  isTitular = false,
}) => {
  const { cotizacion, idCotizacion } = useCotizacion();
  const { editarBeneficiario } = usePaginaCompra();
  const { reset } = useFormContext();
  const router = useCustomRouter();

  const fields = useMemo(
    () =>
      Object.entries(beneficiario)
        .map((field: any) => {
          const containerProps = { className: 'col-md-6' };
          const valueProps = {
            className: 'd-inline-block ml-2',
            style: { fontSize: '16px', margin: '0.3rem 0' },
            estitulo: false
          };
          let item = null;
          if (field[0].includes('esUnTitulo')) {
            item = {
              validacion: 'esUnTitulo',
              campo: '',
              esPrimero: field[0] === 'esUnTitulo1'
            };
          } else {
            item = cotizacion.producto.categoria[camposKey].find(
              (item) => item.codCore === field[0],
            );
          }
          if (item?.showOn && beneficiario[item?.showOn?.codCore] !== item?.showOn?.value) {
            return null;
          }
          if (!item) return null;

          let value: any = field[1];

          switch (item.validacion) {
            case 'desplegable':
              if (item.multiple !== true && item.multiple !== 'true') {

                value = field[1]?.split('|')[1];
              } else {
                value = value?.map?.((item, index) => (
                  <React.Fragment key={index}>
                    <li style={{ padding: '0 0 0 0', margin: '0 0 0 0' }}>
                      {item?.split?.('|')[1]}
                    </li>
                  </React.Fragment>
                ));
              }

              break;
            case 'subForm':
              containerProps.className = 'col-12';
              valueProps.className = 'w-100';
              value = (
                <React.Fragment>
                  <DataTable
                    value={field[1]}
                    className="p-datatable-sm p-datatable-gridlines w-100"
                    autoLayout
                  >
                    <Column
                      header="#"
                      bodyClassName="text-center"
                      //@ts-ignore
                      body={(_, data) => data?.rowIndex + 1}
                      style={{ width: '50px' }}
                    />
                    {item?.fields?.map?.((field, key) => (
                      <Column key={key} header={field?.campo} field={field?.codCore} />
                    ))}
                  </DataTable>
                </React.Fragment>
              );
              break;

            case 'archivo':
              value = (
                <a target="_blank" href={field[1]}>
                  Ver archivo
                </a>
              );
              break;

            case 'esUnTitulo':
              containerProps.className = 'col-md-12 position-relative';
              valueProps.estitulo = true;
              value = (
                <div>
                  {
                    !item.esPrimero && <><br /> <hr className="position-absolute m-auto" style={{ "width": "90%", "background": "#c1c1c1", "left": "0", "right": "0" }} /><br /></>
                  }

                  <p className="titulo-grupo">
                    <strong className="d-inline-block" style={{ fontSize: '18px' }}>
                      {field[1]}</strong> </p>
                </div>
              );
              break;

            default:
              break;
          }
          return {
            label: `${item.campo} ${item.validacion === 'esUnTitulo' ? '' : ':'}`, value, containerProps, valueProps
          };
        })
        .filter((field) => field !== null),
    [beneficiario, camposKey, cotizacion.producto.categoria],
  );

  const onEditar = () => {
    if (isTitular || cotizacion.beneficiarioIgualTitularChecked) {
      return router.push(`/newRegistro/${idCotizacion} `);
    }
    router.push(`/newPaginaCompra/${idCotizacion}?index=${index}`);
  };

  const nTitulos = fields.filter(({ valueProps }) => !!valueProps?.estitulo).length === 1;
  const categoria = cotizacion?.producto?.categoria ?? {};
  return (
    <div className="row pt-3">
      {showHeader && (
        <>
          <div className="col-8 ">
            <div className="d-flex flex-row">
              {isTitular && <h4 className="font-weight-bold">Titular</h4>}
              {!isTitular && (
                <h4 className="font-weight-bold">
                  {(categoria?.aplicadoA ?? '') || (categoria?.CamposBeneficiariosInfo?.labelBeneficiarioBien ?? '')} ({index + 1})
                </h4>
              )}
              <button
                className="ml-2"
                type="button"
                onClick={onEditar}
                style={{
                  backgroundColor: 'white',
                  borderTop: 'none',
                  borderRight: 'none',
                  borderBottom: 'solid 1px #2186f6',
                  borderLeft: 'none',
                  color: '#2186f6',
                  height: '30px',
                  width: '80px',
                  outline: 'none',
                }}
              >
                <i className="pi pi-pencil mr-2" />
                Editar
              </button>
            </div>
          </div>
          <div className="col-4">
            {showDelete && cotizacion?.flujoPlugin !== '24' && <ButtonBar beneficiario={beneficiario} index={index} />}
          </div>
        </>
      )}

      <div
        className="col-12"
        style={{ borderBottom: 'solid 1px #979797' }}
      >
        <div
          className="row justify-content-between mt-2 py-4"
          style={{ backgroundColor: '#fafafa' }}
        >
          {fields.map((field, i) => {
            if (field?.label === ' ' && fields[i + 1]?.label === ' ') return null
            if (nTitulos && field.valueProps.estitulo) return null;
            return (
              <div key={i} {...field?.containerProps}>
                <span className="d-inline-block" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  {field.label}
                  <span className={field?.valueProps?.className} style={{ ...field.valueProps.style, fontWeight: 'normal', paddingLeft: 4 }}>{typeof field?.value === 'boolean' ? <Checkbox
                    checked={field?.value} /> : field.value}</span>
                </span>
              </div>
            )
          })
          }
        </div>
      </div>
    </div>
  );
};

export default BeneficiarioItem;
